module.exports = __webpack_public_path__ + "static/img/5-联系我们@2x.587ff1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-img/5-联系我们@2x.png
// module id = YVdO
// module chunks = 17